<template>
	<v-footer app fixed dark>
		<div class="ml-4">&copy; {{ currentYear }}&nbsp;<b>{{ copyright }}</b></div>
	</v-footer>
</template>

<script>
import moment from 'moment'

export default {
	props: {
		copyright: String,
	},
	computed: {
		currentYear() {
			return moment().format('YYYY')
		},
	},
}
</script>
